// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stock', {
        url: '/stock',
        parent: 'main',
        abstract: true,
        templateUrl: 'main/stock/stock.tpl.html',
        controller: 'MainStockController as vm'
    });
}

// @ngInject
function MainStockController() {
    var vm = this;
}

angular.module('main.stock', ['stock.api', 'inventorying.api', 'stock.articles', 'stock.scannerinventorying', 'stock.stockpickinglist', 'stock.stockValueReports', 'stock.soldStockReports', 'stock.saleThroughputReports', 'stock.productReports'])
    .config(stateConfig)
    .controller('MainStockController', MainStockController);
